export const LAT_MIN_BRASIL = -33.75;
export const LAT_MAX_BRASIL = 5.27;
export const LNG_MIN_BRASIL = -73.99;
export const LNG_MAX_BRASIL = -28.63;

export const LAT_INICIAL_FALLBACK = -17.539876;
export const LNG_INICIAL_FALLBACK = -39.742164;
